const DRAFT_ACTION_QUERY_PARAM = 'draftAction';
const BANK_ID_QUERY_PARAM = 'bankId';
const APPLICATION_ID_QUERY_PARAM = 'applicationId';

/** Что анкета должна сделать с черновиком. Пустой `/short-form/` занят другими входами, в том числе
    ловушками, поэтому намерение передаём явным флагом, а не отсутствием параметров. */
export type TDraftAction = 'new' | 'continue';

export interface IShortFormUrlOptions {
  /* Ссылку с базой и applicationId формирует бэк: у нас нет ни базы, ни заявки до его ответа */
  redirectUrl: string | null;
  draftAction: TDraftAction;
  bankId?: number | null;
}

export const buildShortFormUrl = ({ redirectUrl, draftAction, bankId }: IShortFormUrlOptions): string | null => {
  if (!redirectUrl) {
    return null;
  }

  try {
    const url = new URL(redirectUrl);

    url.searchParams.set(DRAFT_ACTION_QUERY_PARAM, draftAction);

    if (bankId != null) {
      url.searchParams.set(BANK_ID_QUERY_PARAM, String(bankId));
    }

    /* У продолжаемого черновика уже есть свой расчёт — applicationId свежей заявки калькулятора его перебил бы */
    if (draftAction === 'continue') {
      url.searchParams.delete(APPLICATION_ID_QUERY_PARAM);
    }

    return url.toString();
  } catch {
    return null;
  }
};
